import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'

Vue.use(Vuex)
Vue.prototype.$vuex = Vuex;

export default new Vuex.Store({
    state,  //全局需要访问的state对象
    mutations
})